<div class="bloc">
   
    <img src="assets/logo_login.png" class="logo" alt="safaera logo with slogan only planes cheveres">
    <br>
    <br>

    <button mat-raised-button color="primary">
        <a href="https://apps.apple.com/app/safaera/id6467809468" class="flex">
           <img class="store-logo" src="assets/apple-icon.png" alt="">  Descargar en App Store
        </a>
    </button>
    <br>
    <button mat-raised-button color="primary">
        <a href="https://play.google.com/store/apps/details?id=io.app.safaera&pcampaignid=web_share">
            <img class="store-logo" src="assets/google-play-icon.png" alt="">  Descargar en Play Store
        </a>
    </button>
</div>